import { memo } from 'react';

import { useAccessContext } from '../../../AccessProvider/AccessProvider';
import { useIdentity } from '../../../IdentityProvider/IdentityProvider';

import { UserAvatarBase } from './UserAvatarBase';

export const UserAvatar = memo(() => {
  const { accesses } = useAccessContext();
  const { isLoggedIn, initials } = useIdentity();

  return (
    <UserAvatarBase
      access={accesses}
      isLoggedIn={isLoggedIn}
      initials={initials}
    />
  );
});
UserAvatar.displayName = 'UserAvatar';
